@if (notification; as notification) {
  <div class="fixed bottom-5 right-5 bg-primary z-[9999999] p-5 flex items-center space-x-3 rounded-md max-w-sm">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.14 80.14" class="size-10">
      <path id="circle-check"
        d="M0,40.07A40.07,40.07,0,1,1,40.07,80.14,40.067,40.067,0,0,1,0,40.07Zm58.2-6.918a4.383,4.383,0,0,0-6.2-6.2L35.061,43.889l-6.918-6.918a4.383,4.383,0,0,0-6.2,6.2L31.962,53.186a4.393,4.393,0,0,0,6.2,0Z"
        fill="#fff"/>
      </svg>
      <span class="text-white">{{ notification.message }}</span>
    </div>
  }
